// Lightweight theme constants for the Parent UI
export const BLUE_PRIMARY = '#3B82F6';
export const BLUE_PRIMARY_DARK = '#1E40AF';
export const BLUE_PAGE_BG = '#EAF3FF';
export const BLUE_HEADER_BG = '#D7E8FF';
export const BLUE_HEADER_TEXT = '#0F1E56';
export const BLUE_SOFT_SURFACE = '#F0F6FF';
export const DANDU_INSTAGRAM_URL = 'https://www.instagram.com/dandu.tr/';
